(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleContent extends HTMLElement {
    #motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      for (const details of this.querySelectorAll('details')) {
        this.#bind(details);
      }
    }

    #bind(details) {
      if (details.dataset.collapsibleBound === 'true') return;

      details.dataset.collapsibleBound = 'true';

      const summary = details.querySelector('summary');
      const panel = details.querySelector('.collapsible-content__row-panel');

      if (!summary || !panel) return;

      panel.style.height = details.open ? 'auto' : '0px';

      if (details.open) {
        details.classList.add('is-expanded');
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (details.dataset.animating === 'true') return;

        if (details.open) {
          this.#close(details, panel);
          return;
        }

        this.#open(details, panel);
      });
    }

    #setRowScheme(details, expanded) {
      if (this.dataset.style !== 'product_details') return;

      const row = details.closest('.collapsible-content__row');
      const cardScheme = this.dataset.cardScheme;
      const expandedScheme = this.dataset.expandedScheme;

      if (!row || !cardScheme || !expandedScheme) return;

      if (expanded) {
        row.classList.remove(`color-${cardScheme}`);
        row.classList.add(`color-${expandedScheme}`);
        return;
      }

      row.classList.remove(`color-${expandedScheme}`);
      row.classList.add(`color-${cardScheme}`);
    }

    #open(details, panel) {
      if (this.dataset.style === 'product_details') {
        for (const other of this.querySelectorAll('details')) {
          if (other === details || !other.open) continue;

          const otherPanel = other.querySelector('.collapsible-content__row-panel');

          if (otherPanel) this.#close(other, otherPanel);
        }
      }

      details.dataset.animating = 'true';
      details.open = true;
      details.classList.add('is-expanded');
      this.#setRowScheme(details, true);

      if (this.#motionQuery.matches) {
        panel.style.height = 'auto';
        details.dataset.animating = 'false';
        return;
      }

      panel.style.height = '0px';
      panel.offsetHeight;
      panel.style.height = `${panel.scrollHeight}px`;

      const onEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;

        panel.style.height = 'auto';
        details.dataset.animating = 'false';
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    }

    #close(details, panel) {
      details.dataset.animating = 'true';
      details.classList.remove('is-expanded');
      this.#setRowScheme(details, false);

      if (this.#motionQuery.matches) {
        panel.style.height = '0px';
        details.open = false;
        details.dataset.animating = 'false';
        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;
      panel.offsetHeight;
      panel.style.height = '0px';

      const onEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;

        details.open = false;
        details.dataset.animating = 'false';
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    }
  }

  if (!customElements.get('collapsible-content')) {
    customElements.define('collapsible-content', CollapsibleContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // Close the mobile menu when following an in-page anchor; scroll is CSS (scroll-behavior + scroll-margin-top).
  document.querySelectorAll('.section-header a[href*="#"]').forEach((link) => {
    link.addEventListener('click', () => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      let target = null;

      try {
        const url = new URL(href, window.location.origin);

        if (url.pathname !== window.location.pathname || !url.hash) return;

        target = document.querySelector(decodeURIComponent(url.hash));
      } catch (error) {
        return;
      }

      if (!target) return;

      const headerDrawer = link.closest('header-drawer');
      if (!headerDrawer) return;


      const mainDetails = headerDrawer.querySelector('details.menu-drawer-container');
      if (!mainDetails?.hasAttribute('open')) return;

      const summary = mainDetails.querySelector('summary');
      headerDrawer.closeMenuDrawer(new Event('click'), summary);
    });
  });

  const syncHeaderHeight = () => {
    const headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    document.documentElement.style.setProperty('--header-height', `${headerSection.offsetHeight}px`);
  };

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-features"] && !Shopify.designMode) return;
  try {
    
  class ImageWithFeaturesCards extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-stagger')) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.setAttribute('data-visible', '');
        return;
      }

      this.setAttribute('data-prepared', '');

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            this.setAttribute('data-visible', '');
            this.observer.disconnect();
            break;
          }
        },
        { threshold: 0.25 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('image-with-features-cards')) {
    customElements.define('image-with-features-cards', ImageWithFeaturesCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  class MarqueeBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.content = this.querySelector('[data-marquee-content]');

      if (!this.track || !this.content) return;

      this.speed = Number(this.dataset.speed) || 50;
      this.onMotionChange = () => this.#onMotionChange();
      this.onSetup = () => this.#setup();

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionQuery.addEventListener('change', this.onMotionChange);

      this.#setup();

      this.resizeObserver = new ResizeObserver(this.onSetup);
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
    }

    #setup() {
      if (!this.track || !this.content) return;

      this.track.removeAttribute('data-animating');

      while (this.track.children.length > 1) {
        this.track.lastElementChild.remove();
      }

      if (this.content.scrollWidth === 0 || this.offsetWidth === 0) return;

      const minWidth = this.offsetWidth * 2;
      let safety = 0;

      while (this.track.scrollWidth < minWidth && safety < 20) {
        this.track.appendChild(this.content.cloneNode(true));
        safety += 1;
      }

      const fragment = document.createDocumentFragment();

      for (const child of [...this.track.children]) {
        fragment.appendChild(child.cloneNode(true));
      }

      this.track.appendChild(fragment);

      const distance = this.track.scrollWidth / 2;
      const duration = distance / this.speed;

      this.style.setProperty('--marquee-duration', `${duration}s`);

      if (!this.motionQuery?.matches) {
        this.track.setAttribute('data-animating', '');
      }
    }

    #onMotionChange() {
      if (!this.track) return;

      if (this.motionQuery.matches) {
        this.track.removeAttribute('data-animating');
        return;
      }

      if (this.track.children.length > 1) {
        this.track.setAttribute('data-animating', '');
      }
    }
  }

  if (!customElements.get('marquee-banner')) {
    customElements.define('marquee-banner', MarqueeBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-feature-cards"] && !Shopify.designMode) return;
  try {
    
  class MediaFeatureCards extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-mfc-media]');
      this.video = this.querySelector('.media-feature-cards__video');
      this.cards = [...this.querySelectorAll('[data-mfc-card]')];
      this.buttons = [...this.querySelectorAll('[data-mfc-card-button]')];
      this.images = [...this.querySelectorAll('[data-mfc-image]')];
      this.track = this.querySelector('[data-mfc-track]');
      this.prevButton = this.querySelector('[data-mfc-prev]');
      this.nextButton = this.querySelector('[data-mfc-next]');
      this.dots = [...this.querySelectorAll('[data-mfc-dot]')];
      this.activeIndex = -1;
      this.hasVideo = this.hasAttribute('data-has-video') && Boolean(this.video);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.#prepareVideo();

      this.onCardClick = (event) => this.#onCardClick(event);
      this.onPrev = (event) => this.#onPrev(event);
      this.onNext = (event) => this.#onNext(event);
      this.onDotClick = (event) => this.#onDotClick(event);
      this.onVideoEnded = () => this.#onVideoEnded();
      this.onMotionChange = () => this.#onMotionChange();

      for (const button of this.buttons) {
        button.addEventListener('click', this.onCardClick);
      }

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);

      for (const dot of this.dots) {
        dot.addEventListener('click', this.onDotClick);
      }

      if (this.video) {
        this.video.addEventListener('ended', this.onVideoEnded);
      }

      this.motionQuery.addEventListener('change', this.onMotionChange);

      if (this.motionQuery.matches || !this.hasVideo) {
        this.#enterFeatures(0);
      } else {
        this.#observeViewport();
      }

      this.#observeCards();
      this.#updateNav();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.cardObserver) this.cardObserver.disconnect();
      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
      if (this.video) this.video.removeEventListener('ended', this.onVideoEnded);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);

      for (const button of this.buttons) {
        button.removeEventListener('click', this.onCardClick);
      }

      for (const dot of this.dots) {
        dot.removeEventListener('click', this.onDotClick);
      }
    }

    #prepareVideo() {
      if (!this.video) return;

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.video.removeAttribute('controls');
      this.video.controls = false;
      this.video.preload = 'auto';
    }

    #observeCards() {
      if (!this.track || this.cards.length === 0) return;

      this.cardObserver = new IntersectionObserver(
        (entries) => {
          if (window.matchMedia('(min-width: 990px)').matches) return;

          for (const entry of entries) {
            if (entry.isIntersecting) {
              const index = Number(entry.target.dataset.index);
              if (this.activeIndex !== index) {
                this.#enterFeatures(index);
              }
            }
          }
        },
        {
          root: this.track,
          threshold: 0.6,
        }
      );

      for (const card of this.cards) {
        this.cardObserver.observe(card);
      }
    }

    #observeViewport() {
      const target = this.media || this;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (this.dataset.phase !== 'idle') continue;

            this.#playVideo();
          }
        },
        {
          threshold: 0.35,
          rootMargin: '0px',
        }
      );

      this.observer.observe(target);

      requestAnimationFrame(() => {
        if (this.dataset.phase !== 'idle') return;
        if (this.#isMediaInView()) this.#playVideo();
      });
    }

    #isMediaInView() {
      const el = this.media || this;
      const rect = el.getBoundingClientRect();
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const visible = Math.min(rect.bottom, viewHeight) - Math.max(rect.top, 0);

      return visible > rect.height * 0.35;
    }

    #playVideo() {
      if (!this.video || this.dataset.phase !== 'idle') return;

      this.dataset.phase = 'playing';
      this.#prepareVideo();

      const playPromise = this.video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          this.#enterFeatures(0);
        });
      }
    }

    #onVideoEnded() {
      this.#enterFeatures(0);
    }

    #enterFeatures(index) {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.video && !this.video.paused) {
        this.video.pause();
      }

      this.dataset.phase = 'features';
      this.#activate(index);
    }

    #onCardClick(event) {
      const card = event.currentTarget.closest('[data-mfc-card]');
      if (!card) return;

      const index = Number(card.dataset.index);
      this.#goTo(index);
    }

    #onPrev(event) {
      event.preventDefault();
      const nextIndex = Math.max(0, this.activeIndex <= 0 ? 0 : this.activeIndex - 1);
      this.#goTo(nextIndex);
    }

    #onNext(event) {
      event.preventDefault();
      const max = this.cards.length - 1;
      const nextIndex = Math.min(max, this.activeIndex < 0 ? 0 : this.activeIndex + 1);
      this.#goTo(nextIndex);
    }

    #onDotClick(event) {
      event.preventDefault();
      const index = Number(event.currentTarget.dataset.index);
      this.#goTo(index);
    }

    #goTo(index) {
      this.#enterFeatures(index);
      this.#scrollCardIntoView(index);
    }

    #scrollCardIntoView(index) {
      const card = this.cards[index];
      if (!card || !this.track) return;
      if (window.matchMedia('(min-width: 990px)').matches) return;

      const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;

      this.track.scrollTo({
        left: Math.max(0, left),
        behavior: this.motionQuery.matches ? 'auto' : 'smooth',
      });
    }

    #activate(index) {
      if (index < 0 || index >= this.cards.length) return;
      if (index === this.activeIndex && this.dataset.phase === 'features') {
        this.#updateNav();
        return;
      }

      this.activeIndex = index;

      for (const card of this.cards) {
        const isActive = Number(card.dataset.index) === index;
        card.classList.toggle('is-active', isActive);

        const button = card.querySelector('[data-mfc-card-button]');
        if (button) button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      for (const image of this.images) {
        const imageIndex = Number(image.getAttribute('data-mfc-image'));
        image.classList.toggle('is-active', imageIndex === index);
      }

      for (const dot of this.dots) {
        const isActive = Number(dot.dataset.index) === index;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }

      this.#updateNav();
    }

    #updateNav() {
      if (!this.prevButton || !this.nextButton) return;

      const atStart = this.activeIndex <= 0;
      const atEnd = this.activeIndex >= this.cards.length - 1;

      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
    }

    #onMotionChange() {
      if (this.motionQuery.matches && this.dataset.phase !== 'features') {
        this.#enterFeatures(Math.max(0, this.activeIndex));
      }
    }
  }

  if (!customElements.get('media-feature-cards')) {
    customElements.define('media-feature-cards', MediaFeatureCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      this.slides = [...this.querySelectorAll('[data-reviews-slide]')];
      this.dots = [...this.querySelectorAll('[data-reviews-dot]')];
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Math.max(3, Number(this.dataset.speed) || 5) * 1000;
      this.staticDesktop = this.hasAttribute('data-static-desktop');
      this.activeIndex = 0;
      this.autoplayTimer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.track || this.slides.length < 2) return;

      this.onScroll = () => this.#onScroll();
      this.onDotClick = (event) => this.#onDotClick(event);
      this.onPointerEnter = () => this.#pauseAutoplay();
      this.onPointerLeave = () => this.#resumeAutoplay();
      this.onFocusIn = () => this.#pauseAutoplay();
      this.onFocusOut = () => this.#resumeAutoplay();
      this.onVisibilityChange = () => this.#onVisibilityChange();
      this.onResize = () => this.#onResize();
      this.onMotionChange = () => this.#onMotionChange();

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      window.addEventListener('resize', this.onResize);
      this.motionQuery.addEventListener('change', this.onMotionChange);

      for (const dot of this.dots) {
        dot.addEventListener('click', this.onDotClick);
      }

      this.#syncActiveFromScroll();
      this.#setupAutoplay();
    }

    disconnectedCallback() {
      this.#clearAutoplay();

      if (this.track) this.track.removeEventListener('scroll', this.onScroll);

      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      window.removeEventListener('resize', this.onResize);

      if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);

      for (const dot of this.dots) {
        dot.removeEventListener('click', this.onDotClick);
      }
    }

    #isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    #carouselActive() {
      if (this.slides.length < 2) return false;
      if (this.#isDesktop() && this.staticDesktop) return false;

      return true;
    }

    #onDotClick(event) {
      event.preventDefault();
      const index = Number(event.currentTarget.dataset.index);
      this.#goTo(index);
      this.#restartAutoplay();
    }

    #onScroll() {
      window.requestAnimationFrame(() => this.#syncActiveFromScroll());
    }

    #onResize() {
      this.#syncActiveFromScroll();
      this.#setupAutoplay();
    }

    #onMotionChange() {
      this.#setupAutoplay();
    }

    #onVisibilityChange() {
      if (document.hidden) {
        this.#pauseAutoplay();
      } else {
        this.#resumeAutoplay();
      }
    }

    #syncActiveFromScroll() {
      if (!this.#carouselActive()) {
        this.#setActive(0);
        return;
      }

      const trackRect = this.track.getBoundingClientRect();
      const target = this.#isDesktop()
        ? trackRect.left + 1
        : trackRect.left + trackRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      for (const [index, slide] of this.slides.entries()) {
        const slideRect = slide.getBoundingClientRect();
        const slidePoint = this.#isDesktop()
          ? slideRect.left
          : slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slidePoint - target);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      }

      this.#setActive(closestIndex);
    }

    #setActive(index) {
      if (this.activeIndex === index) return;

      this.activeIndex = index;

      for (const [dotIndex, dot] of this.dots.entries()) {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }
    }

    #goTo(index) {
      const slide = this.slides[index];
      if (!slide || !this.track || !this.#carouselActive()) return;

      const scrollLeft = this.#isDesktop()
        ? slide.offsetLeft
        : Math.max(0, slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2);

      this.track.scrollTo({
        left: scrollLeft,
        behavior: this.motionQuery.matches ? 'auto' : 'smooth',
      });

      this.#setActive(index);
    }

    #setupAutoplay() {
      this.#clearAutoplay();

      if (!this.autoplayEnabled) return;
      if (this.motionQuery.matches) return;
      if (document.hidden) return;
      if (!this.#carouselActive()) return;

      this.autoplayTimer = window.setInterval(() => {
        const nextIndex = (this.activeIndex + 1) % this.slides.length;
        this.#goTo(nextIndex);
      }, this.autoplaySpeed);
    }

    #clearAutoplay() {
      if (!this.autoplayTimer) return;

      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    #pauseAutoplay() {
      this.#clearAutoplay();
    }

    #resumeAutoplay() {
      this.#setupAutoplay();
    }

    #restartAutoplay() {
      this.#setupAutoplay();
    }
  }

  if (!customElements.get('reviews-carousel')) {
    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-before-after"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.handle = this.querySelector('[data-ba-handle]');

      if (!this.handle) return;

      this.position = Number(this.dataset.position) || 50;
      this.dragging = false;

      this.onPointerDown = (event) => this.#onPointerDown(event);
      this.onPointerMove = (event) => this.#onPointerMove(event);
      this.onPointerUp = (event) => this.#onPointerUp(event);
      this.onKeyDown = (event) => this.#onKeyDown(event);

      this.addEventListener('pointerdown', this.onPointerDown);
      this.handle.addEventListener('keydown', this.onKeyDown);
      this.#setPosition(this.position);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.handle?.removeEventListener('keydown', this.onKeyDown);
      this.#unbindDrag();
    }

    #setPosition(value) {
      this.position = Math.min(100, Math.max(0, value));
      this.style.setProperty('--ba-position', `${this.position}%`);
      this.handle?.setAttribute('aria-valuenow', String(Math.round(this.position)));
    }

    #positionFromEvent(event) {
      const rect = this.getBoundingClientRect();

      if (rect.width === 0) return this.position;

      return ((event.clientX - rect.left) / rect.width) * 100;
    }

    #onPointerDown(event) {
      if (event.button != null && event.button !== 0) return;

      this.dragging = true;
      this.setAttribute('data-dragging', '');
      this.#setPosition(this.#positionFromEvent(event));

      this.setPointerCapture?.(event.pointerId);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);

      event.preventDefault();
    }

    #onPointerMove(event) {
      if (!this.dragging) return;

      this.#setPosition(this.#positionFromEvent(event));
    }

    #onPointerUp(event) {
      if (!this.dragging) return;

      this.dragging = false;
      this.removeAttribute('data-dragging');
      this.#unbindDrag();

      if (event?.pointerId != null) {
        this.releasePointerCapture?.(event.pointerId);
      }
    }

    #unbindDrag() {
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
    }

    #onKeyDown(event) {
      let next = this.position;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          next -= 2;
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          next += 2;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = 100;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.#setPosition(next);
    }
  }

  if (!customElements.get('before-after-slider')) {
    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  class StatsCounter extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-animate')) return;

      this.values = [...this.querySelectorAll('[data-stat-value]')];

      if (this.values.length === 0) return;

      this.duration = Number(this.dataset.duration) || 1400;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reducedMotion) {
        this.setAttribute('data-counted', '');
        return;
      }

      this.#prepare();
      this.setAttribute('data-prepared', '');

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            this.#animate();
            this.observer.disconnect();
            break;
          }
        },
        { threshold: 0.35 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();

      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    #parse(text) {
      const match = String(text).trim().match(/^([^\d-]*)(-?\d+(?:[.,]\d+)?)(.*)$/);

      if (!match) return null;

      const rawNumber = match[2].replace(',', '.');
      const decimals = (rawNumber.split('.')[1] || '').length;

      return {
        prefix: match[1],
        target: Number(rawNumber),
        suffix: match[3],
        decimals,
      };
    }

    #prepare() {
      for (const el of this.values) {
        const parsed = this.#parse(el.textContent);

        if (!parsed || Number.isNaN(parsed.target)) continue;

        el.dataset.prefix = parsed.prefix;
        el.dataset.suffix = parsed.suffix;
        el.dataset.target = String(parsed.target);
        el.dataset.decimals = String(parsed.decimals);
        el.textContent = `${parsed.prefix}0${parsed.suffix}`;
      }
    }

    #format(value, decimals, prefix, suffix) {
      const rounded = decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));

      return `${prefix}${rounded}${suffix}`;
    }

    #easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    #animate() {
      this.setAttribute('data-counting', '');

      const start = performance.now();
      const items = [];

      for (const el of this.values) {
        if (el.dataset.target == null) continue;

        items.push({
          el,
          target: Number(el.dataset.target),
          decimals: Number(el.dataset.decimals) || 0,
          prefix: el.dataset.prefix || '',
          suffix: el.dataset.suffix || '',
        });
      }

      const tick = (now) => {
        const progress = Math.min((now - start) / this.duration, 1);
        const eased = this.#easeOutCubic(progress);

        for (const item of items) {
          item.el.textContent = this.#format(
            item.target * eased,
            item.decimals,
            item.prefix,
            item.suffix
          );
        }

        if (progress < 1) {
          this.rafId = requestAnimationFrame(tick);
          return;
        }

        for (const item of items) {
          item.el.textContent = this.#format(item.target, item.decimals, item.prefix, item.suffix);
        }

        this.removeAttribute('data-counting');
        this.setAttribute('data-counted', '');
      };

      this.rafId = requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('stats-counter')) {
    customElements.define('stats-counter', StatsCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCartBar extends HTMLElement {
    connectedCallback() {
      this.innerBar = this.querySelector('.sticky-atc__inner');
      this.onScroll = () => this.#updateVisibility();
      this.onResize = () => {
        this.#setThreshold();
        this.#updateVisibility();
      };

      this.#setThreshold();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.#updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    #setThreshold() {
      this.threshold = window.innerHeight;
      this.bottomOffset = Math.max(this.offsetHeight, 1);
    }

    #updateVisibility() {
      const scrollBottom = window.scrollY + window.innerHeight;
      const nearBottom =
        scrollBottom >= document.documentElement.scrollHeight - this.bottomOffset;
      const visible = window.scrollY >= this.threshold && !nearBottom;

      this.classList.toggle('sticky-atc--visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (!this.innerBar) return;

      if (visible) {
        this.innerBar.removeAttribute('inert');
      } else {
        this.innerBar.setAttribute('inert', '');
      }
    }
  }

  if (!customElements.get('sticky-add-to-cart-bar')) {
    customElements.define('sticky-add-to-cart-bar', StickyAddToCartBar);
  }

  } catch(e) { console.error(e); }
})();
})();
